import {Injectable} from '@angular/core';
import {FnApplicationHelper} from '../services/fn-application.helper';
import {FNExceptionJson} from './fn-exception-json';

/**
 * service  mainly designed to handle try-catch exception(may be manual) and
 * for auto genrate error there is FNErrorHandler sevice that implement ErrorHandler(Angular)
 */
@Injectable()

export class FnExceptionService {

  /**
   * Creates an instance of fn exception service.
   */
  constructor() {
  }

  /**
   * private variable used to store FnApplicationHelper refrence
   */
  private fnAppHelper: FnApplicationHelper;

  /**
   * method to set FnApplicationHelper refrence.
   * @param fnAplicationHelper FnApplicationHelper refrence
   */
  public setFnApplicationHelper(fnAplicationHelper: FnApplicationHelper) {
    this.fnAppHelper = fnAplicationHelper;
  }

  /**
   * method to get fn FnApplicationHelper refrence
   * @returns  
   */
  public getFnApplicationHelper() {
    return this.fnAppHelper;
  }

  /**
   * method to print exception on console if logToConsole true 
   * and send exception to server if FnApplication ref is not undefined or null
   * @param exception Object to print on console and used to set Properties of Object to send on server.
   * @param [logToConsole] 
   */
  public logException(exception: any, logToConsole?: boolean) {
    if (logToConsole) {
      console.error(exception);
    }

    if (this.fnAppHelper.getApplication()) {
      const fnExpJson: FNExceptionJson = new FNExceptionJson(exception);
      this.fnAppHelper.getApplication().sendExceptionToServer(fnExpJson);
    }

  }


}
